import React from 'react';
import { StoreButtons, PostPurchaseFooter, postPurchaseLang } from './StoreButtons.jsx';

// Página /app — é pra onde o botão "Abrir o FitClutch" do e-mail de boas-vindas
// aponta (igual à página "Sua jornada fitness começa aqui" do Befit). Só mostra
// os botões das lojas; não depende de quiz nem de pagamento.
const COPY = {
  pt: { a: 'SUA JORNADA', b: 'FITNESS', c: 'COMEÇA AQUI', sub: 'Baixe o FitClutch para abrir seu plano e acompanhar seus treinos.' },
  en: { a: 'YOUR FITNESS', b: 'JOURNEY', c: 'STARTS HERE', sub: 'Download FitClutch to open your plan and track your workouts.' },
};

export default function DownloadScreen() {
  const lang = postPurchaseLang();
  const c = COPY[lang];
  return (
    <div className="phone-frame flex flex-col items-center justify-center safe-top safe-bottom px-6 text-center">
      <img src="/icone-fitclutch-512.png" alt="FitClutch" className="w-16 h-16 rounded-2xl mb-8" />
      <h1 className="font-display text-3xl font-extrabold leading-tight mb-4 uppercase">
        {c.a} <span className="text-cyan">{c.b}</span>
        <br />
        <span className="text-cyan">{c.c}</span>
      </h1>
      <p className="text-ink-muted mb-8 max-w-xs">{c.sub}</p>
      <StoreButtons lang={lang} />
      <PostPurchaseFooter lang={lang} />
    </div>
  );
}
